import httpService from "./httpService";

export default {

    findByDocId(docId) {
        return httpService.get("docInBook/findByDocId", {params: {docId: docId}});
    },
}


// WEBPACK FOOTER //
// ./src/services/docInBookService.js